<page-content [fullPageWidth]="true">
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <test-side-menu
            [tests]="testsLeftMenu"
            [organization]="organization"
            [athleteUser]="athleteUser"
            [testsChange]="testsChange">
        </test-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!is401 && !is404" [title]="'TestsAll'|translate">
        <div class="horizontal-scroll-wrapper">
            <div class="graph-min-600">

                <test-multi-line-borg-chart
                        [showTooltip]="true"
                        title=""
                        [data]="measures?.series.borg"
                        [graphClass]="graphClass"
                ></test-multi-line-borg-chart>
            </div>
        </div>
    </module-content>
</page-content>
